import { Feature, NavLink, SocialLink } from "./types";

export const CTA_URL = "https://tally.so/r/yP64GB";

export const NAV_LINKS: NavLink[] = [
  { id: "reto", label: "El reto", href: "#reto" },
  { id: "modelo", label: "Modelo", href: "#socio" },
  { id: "incluye", label: "Qué incluye", href: "#incluye" },
  { id: "ideal", label: "Perfil de agencia", href: "#ideal" },
];

export const LANDING_COPY = {
  hero: {
    headline:
      "Lanza o consolida tu programa de quinceañeras en Europa con respaldo profesional en destino.",
    subheadline:
      "Diseñamos y coordinamos programas internacionales para agencias que desean lanzar o consolidar su propuesta con estándares claros y acompañamiento profesional en destino.",
    bullets: [
      "Especialización en grupos adolescentes y quinceañeras",
      "Coordinación logística en Europa",
      "Protocolos definidos y control operativo",
      "Soporte antes, durante y después",
    ],
    cta: "Solicitar acceso al programa",
    microcopy: "Exclusivo para agencias · Evaluación previa requerida",
  },
  challenge: {
    title:
      "El verdadero reto de operar programas juveniles internacionales en Europa.",
    intro:
      "Ya sea un programa de quinceañeras o un grupo juvenil mixto, no es solo vender un itinerario. Es asumir responsabilidad, reputación y expectativas muy altas de padres y participantes.",
    problems: [
      "Falta de un operador confiable en Europa que entienda grupos juveniles",
      "Programas armados sobre la marcha que dependen demasiado de personas, no de sistema",
      "Riesgo operativo que puede afectar la imagen de la agencia",
      "Experiencias genéricas que no se diferencian ni justifican el precio",
    ],
  },
  strategicPartner: {
    title: "¿Qué es IBEROTOURS para tu agencia?",
    intro: "IBEROTOURS es tu socio estratégico en destino.",
    affirmations: [
      "No vendemos directamente al cliente final.",
      "No competimos contigo.",
      "Fortalecemos tu oferta.",
    ],
    deliverables: [
      "Programas europeos diseñados específicamente para quinceañeras y grupos juveniles mixtos",
      "Operación en destino con estándares claros",
      "Soporte previo al viaje y acompañamiento durante la experiencia",
      "Un modelo que puedes lanzar, repetir y escalar",
    ],
  },
  identity: {
    title: "Qué es IBEROTOURS",
    somos: [
      "Operador especializado en programas europeos para jóvenes",
      "Equipo con experiencia real operando grupos de quinceañeras",
      "Socio de largo plazo para agencias",
    ],
    noSomos: [
      "Un paquete genérico",
      "Un intermediario sin control operativo",
      "Un operador que vende directo al cliente final",
    ],
    closing:
      "Tu cliente sigue siendo tu cliente. Nosotros fortalecemos tu oferta, no la sustituimos.",
  },
  includes: {
    title: "Qué incluye trabajar con IBEROTOURS",
    intro: "Recibes una solución completa:",
    items: [
      "Diseño del circuito europeo (ciudades, ritmo y narrativa del viaje)",
      "Hoteles, transporte y logística adaptados a grupos juveniles",
      "Coordinación y soporte en destino",
      "Protocolos operativos y de seguridad",
      "Acompañamiento durante el viaje",
      "Soporte para que tu agencia lo presente y lo venda con claridad",
    ],
    outro:
      "Tú te enfocas en tu mercado. Nosotros nos encargamos de que el programa funcione.",
  },
  whyChoose: {
    title: "Por qué las agencias eligen IBEROTOURS",
    reasons: [
      "Programas pensados específicamente para jóvenes de 14 a 16 años",
      "Enfoque en experiencia, seguridad y control operativo",
      "Operación diseñada para repetirse y escalar",
      "Selección cuidadosa de agencias con las que trabajamos",
    ],
    closing:
      "No buscamos volumen. Buscamos relaciones bien alineadas y programas exitosos.",
  },
  fit: {
    title: "Este programa es para agencias que:",
    yes: [
      "Desean lanzar o consolidar su programa de quinceañeras",
      "Valoran la reputación por encima de la improvisación",
      "Buscan respaldo real, no solo proveedores",
      "Quieren operar con estándar profesional desde el inicio",
    ],
    noTitle: "No es para agencias que:",
    no: [
      "Buscan solo el precio más bajo",
      "Improvisan operaciones sensibles",
      "No desean seguir protocolos",
      "Tratan los viajes de quinceañeras como un tour más",
    ],
  },
  finalCta: {
    title:
      "Si deseas lanzar tu programa de quinceañeras con respaldo real, este es el siguiente paso.",
    button: "Solicitar acceso al programa IBEROTOURS",
    formNote: "Formulario confidencial · Sin compromiso",
    microcopy:
      "No vendemos al cliente final. Trabajamos exclusivamente con agencias.",
  },
};

export const FEATURES: Feature[] = [];

export const SOCIAL_LINKS: SocialLink[] = [
  { platform: "LinkedIn", url: "https://www.linkedin.com", icon: "linkedin" },
];

export const WHATSAPP_CONFIG = {
  phoneNumber: "34600000000",
  message:
    "Hola, somos una agencia y queremos solicitar acceso al programa IBEROTOURS.",
  label: "Contactar por WhatsApp",
};

export const COMPANY_INFO = {
  name: "IBEROTOURS",
  tagline:
    "Programas juveniles europeos con operación profesional para agencias.",
  email: "hola@ibero.tours",
  phone: "+34 657 162 607",
  address: "Calle de Manzanares 4, Madrid 28005",
};

export const IMAGES = {
  hero: "/assets/hero-disney-quinceanios.jpg",
  logo: "/assets/ibero-tours-logo-transparent.png",
  logoWhite: "/assets/ibero-tours-logo-transparent.png",
  ogImage: "/assets/hero-disney-quinceanios.jpg",
  diagnostic: "/assets/diagnostic-planning.png",
  operations: "/assets/local-operations.png",
  differentiation: "/assets/teens-happy-europe.png",
  logistics: "/assets/logistics-bus.png",
  security: "/assets/diagnostic-planning.png",
  ideal: "/assets/operations-coordinator.png",
};
